export const Seal = ({ className = "" }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
    <circle cx="60" cy="60" r="57" fill="none" stroke="#D4AF37" strokeWidth="1.5" />
    <circle cx="60" cy="60" r="49" fill="none" stroke="#D4AF37" strokeWidth="0.75" />
    <circle cx="60" cy="60" r="40" fill="#5C0A0A" />
    <text x="60" y="46" textAnchor="middle" fill="#D4AF37" fontFamily="Cormorant Garamond, serif" fontSize="12" letterSpacing="1">Since</text>
    <text x="60" y="76" textAnchor="middle" fill="#F0E6D2" fontFamily="Cormorant Garamond, serif" fontSize="26" fontWeight="600">1997</text>
    <g fill="#D4AF37">
      <circle cx="60" cy="8" r="1.4" />
      <circle cx="60" cy="112" r="1.4" />
      <circle cx="8" cy="60" r="1.4" />
      <circle cx="112" cy="60" r="1.4" />
    </g>
  </svg>
);
